import React from 'react';
import { List } from 'antd';
import SummaryCard from './SummaryCard';
import FileItem from '@/components/ProjectDetails/Cards/Items/FileItem';
import { MergedFileModel } from '@/typings/models/Lead';
import { F } from '@/utils/intl';

export interface FilesCardProps {
  files: MergedFileModel[];
  count: number;
  onAdd?: () => void;
  onShowAll?: () => void;
}

const FilesCard: React.FC<FilesCardProps> = ({
  files,
  count,
  onAdd,
  onShowAll,
}) => {
  return (
    <SummaryCard
      title={<F id={'entity.file.plural'} defaultMessage={'Files'} />}
      count={count}
      onAdd={onAdd}
      onShowAll={onShowAll}
    >
      <List
        dataSource={files}
        renderItem={(file) => (
          <FileItem openFilesDrawer={onShowAll} file={file} />
        )}
      />
    </SummaryCard>
  );
};

export default FilesCard;
